import React from "react";
import Newnabar from "../components/shared/Newnabar";
import SoloConnectFooter from "../components/shared/SoloConnectFooter";
import SoloConnectMobileFooter from "../components/shared/SoloConnectMobileFooter";
import SEO from "../components/shared/SEO";
import BlogHero from "../components/blog/BlogHero";
import BlogFeaturedPosts from "../components/blog/BlogFeaturedPosts";

export default function Blog() {
  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden bg-white pt-16">
      <SEO
        title="Blog | SoloConnect"
        description="Tips, stories, and guides for solo travelers from the SoloConnect community."
        keywords="travel blog, solo travel tips, travel stories, travel guides, SoloConnect"
      />
      <Newnabar />

      <main className="flex-grow">
        <BlogHero />
        <BlogFeaturedPosts />
      </main>

      <div className="hidden md:block">
        <SoloConnectFooter />
      </div>

      <div className="block md:hidden">
        <SoloConnectMobileFooter />
      </div>
    </div>
  );
}
